import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

import { Button } from '@aurum/ui';

export function LandingPage(): JSX.Element {
  const navigate = useNavigate();

  return (
    <main className="relative min-h-screen overflow-hidden bg-onyx-900">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-40"
        style={{
          background:
            'radial-gradient(ellipse at top, rgba(176,127,28,0.35) 0%, rgba(10,10,11,0) 60%)',
        }}
      />

      <div className="relative z-10 mx-auto flex min-h-screen max-w-3xl flex-col items-center justify-center px-8 text-center">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="mb-6 font-body text-sm uppercase tracking-[0.4em] text-aurum-300"
        >
          مرحباً بكم في
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: 'easeOut', delay: 0.15 }}
          className="aurum-gradient-text font-display text-7xl font-semibold leading-none md:text-9xl"
        >
          Straw
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5 }}
          className="mt-6 max-w-xl font-display text-2xl text-cream-100"
        >
          تجربة قهوة فاخرة مصنوعة لكم بحب.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.85 }}
          className="mt-12 flex flex-col items-center gap-3"
        >
          <Button size="lg" onClick={() => navigate('/menu')}>
            استعراض القائمة
          </Button>
          <p className="font-body text-xs text-onyx-100">
            iPad · Straw Digital Menu v0.1
          </p>
        </motion.div>
      </div>
    </main>
  );
}
